import React, { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import {
  Container,
  Box,
  Typography,
  Grid,
  TextField,
  Button,
} from "@mui/material";

import { validateEmail } from "utils/functions";
import { createFeedback } from "context/actions/feedbacks";
import Alert from "@mui/material/Alert";
import { MapPin, ChevronDown } from "react-feather";

import { getPageAllList, getPageList } from "context/actions/pages";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import CustomSnackBar from "components/CustomSnackBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSquareFacebook,
  faSquareInstagram,
  faSquareYoutube,
  faSquareTwitter,
} from "@fortawesome/free-brands-svg-icons";

let successTimeout = null;

const Footer = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [feedback, setFeedback] = useState("");
  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState({
    name: false,
    email: false,
    feedback: false,
  });

  const [snack, setSnack] = useState({
    isOpen: false,
    msg: "",
    type: "success",
  });

  const { t } = useTranslation();

  const [menus, setMenus] = useState([]);

  useEffect(() => {
    getMenus();
  }, []);

  const getMenus = async () => {
    const datas = await getPageList(false);
    if (datas.status === "success") setMenus(datas.data);
  };

  const handleCloseSnack = () => {
    setSnack({ ...snack, isOpen: false });
  };

  const handleFeedbackSend = async () => {
    let hasError = false;
    if (name.length === 0) {
      errors.name = true;
      hasError = true;
    } else {
      errors.name = false;
    }

    if (!validateEmail(email)) {
      errors.email = true;
      hasError = true;
    } else {
      errors.email = false;
    }

    if (feedback.length === 0) {
      errors.feedback = true;
      hasError = true;
    } else {
      errors.feedback = false;
    }

    setErrors({ ...errors });

    if (hasError) {
      if (!validateEmail(email))
        setSnack({
          isOpen: true,
          msg: t("invalid_email"),
          type: "error",
        });
      else
        setSnack({
          isOpen: true,
          msg: t("fill_form_full"),
          type: "error",
        });
      return;
    }

    const result = await createFeedback({
      name,
      email,
      feedback,
    });

    if (result.status === "success") {
      setSnack({
        isOpen: true,
        msg: t("send_successfully"),
        type: "success",
      });
      setName("");
      setEmail("");
      setFeedback("");
      setSuccess(true);
    }
  };

  useEffect(() => {
    successTimeout = setTimeout(() => setSuccess(false), 2500);

    return () => {
      if (successTimeout) clearTimeout(successTimeout);
    };
  }, [success]);

  const onNameChange = (e) => setName(e.target.value);
  const onEmailChange = (e) => setEmail(e.target.value);
  const onFeedbackChange = (e) => setFeedback(e.target.value);

  const RenderChildren = ({ menu }) => {
    return (
      <>
        {!menu.children.length && (
          <Link
            href={menu.url ? menu.url : "/content/" + menu.id}
            passHref
            target={
              (menu.url && menu.url.charAt(0) === "/") || !menu.url
                ? "_self"
                : "_blank"
            }
            style={{ marginBottom: 6 }}
          >
            <Typography
              variant={"body1"}
              style={{
                width: "100%",
                fontWeight: "400",
                color: "#000",
                textTransform: "uppercase",
              }}
            >
              {i18n.language === "en" ? menu.nameEng : menu.name}
            </Typography>
          </Link>
        )}
        {menu.children &&
          menu.children.map((ch, ind) => {
            return <RenderChildren key={ind} menu={ch} />;
          })}
      </>
    );
  };

  return (
    <div
      style={{
        backgroundColor: "rgba(10, 36, 88, 0.9)",
        backgroundImage: "url(/footerback.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center bottom",
        backgroundRepeat: "no-repeat",
        color: "#FFFFFF",
      }}
    >
      <Container
        maxWidth={false}
        disableGutters={true}
        style={{
          paddingTop: 30,
          paddingBottom: 60,
          borderTop: "1px solid",
          borderColor: "#cbcbcb75!important",
        }}
        // className="bg-[radial-gradient(circle,_rgba(10,_36,_88,_0.9)_0%,_rgba(10,_36,_88,_1)_90%)]"
        className="bg-[#212F3D]"
        id={"contact"}
      >
        <Container
          maxWidth={"lg"}
          style={{
            marginTop: 44,
          }}
        >
          <Grid container spacing={4}>
            <Grid
              item
              lg={6}
              md={6}
              sm={12}
              xs={12}
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box className="flex flex-row flex-nowrap items-center">
                <Typography variant={"h2"} className="text-white">
                  {t("send_offer")}
                </Typography>
                <Box className="flex-grow ml-5 h-[2px] bg-gradient-to-r from-[#ffa200] to-transparent"></Box>
              </Box>
              <TextField
                sx={{
                  marginTop: 2,
                  "& .MuiOutlinedInput-root": {
                    "& input": {
                      color: "#f2f2f2", // Change the text color (e.g., tomato red)
                    },
                    "& fieldset": {
                      borderColor: "white", // Change the border color
                    },
                    "&:hover fieldset": {
                      borderColor: "white", // Change the border color on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "white", // Change the border color when focused
                    },
                    "& input::placeholder": {
                      color: "white", // Change the placeholder color here
                    },
                  },
                }}
                variant="outlined"
                style={{ marginTop: 20 }}
                placeholder={t("field.your_name")}
                value={name}
                onChange={onNameChange}
                error={errors.name}
              />
              <TextField
                sx={{
                  marginTop: 2,
                  "& .MuiOutlinedInput-root": {
                    "& input": {
                      color: "#f2f2f2", // Change the text color (e.g., tomato red)
                    },
                    "& fieldset": {
                      borderColor: "white", // Change the border color
                    },
                    "&:hover fieldset": {
                      borderColor: "white", // Change the border color on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "white", // Change the border color when focused
                    },
                    "& input::placeholder": {
                      color: "white", // Change the placeholder color here
                    },
                  },
                }}
                variant="outlined"
                style={{ marginTop: 20 }}
                value={email}
                onChange={onEmailChange}
                error={errors.email}
                placeholder={t("field.mail")}
              />
              <TextField
                sx={{
                  marginTop: 2,
                  "& .MuiOutlinedInput-root": {
                    "& input": {
                      color: "#f2f2f2", // Text color
                    },
                    "& fieldset": {
                      borderColor: "white", // Border color
                    },
                    "&:hover fieldset": {
                      borderColor: "white", // Border color on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "white", // Border color when focused
                    },
                    "& textarea": {
                      minHeight: "100px", // Set minimum height here
                    },
                  },
                  "& .MuiInputBase-root": {
                    color: "#f2f2f2", // Ensure the text color is applied to textarea as well
                  },
                  "& .MuiInputBase-input": {
                    color: "#f2f2f2", // Ensure the text color is applied to textarea as well
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "white", // Border color for the outline
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "white", // Change the placeholder color
                  },
                }}
                variant="outlined"
                style={{ marginTop: 20 }}
                placeholder={t("field.write_comment")}
                value={feedback}
                onChange={onFeedbackChange}
                multiline
                error={errors.feedback}
              />
              <Button
                sx={{
                  marginTop: 3,
                  backgroundColor: "white",
                  "&:hover": {
                    backgroundColor: "#f0f0f0", // Optional: Change hover background color
                  },
                }}
                onClick={handleFeedbackSend}
              >
                <Typography
                  variant={"h4"}
                  style={{ color: "#0a2458" }}
                  className="uppercase"
                >
                  {t("field.send")}
                </Typography>
              </Button>
            </Grid>

            <Grid
              item
              lg={6}
              md={6}
              sm={12}
              xs={12}
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box className="flex flex-row flex-nowrap items-center">
                <Typography variant={"h2"} className="text-white">
                  {t("contact")}
                </Typography>
                <Box className="flex-grow ml-5 h-[2px] bg-gradient-to-r from-[#ffa200] to-transparent"></Box>
              </Box>
              <Box className={"mt-4"}>
                {i18n.language === "en" ? (
                  <Typography variant="h3">
                    Blue Sky Tower, Peace avenue-17
                    <br />
                    Sukhbaatar district, Ulaanbaatar-14240
                    <br />
                    Tel: 7711 1918
                    <br />
                    E-mail: Khanlor2021@gmail.com
                    <br />
                    https: hanlor.mn
                  </Typography>
                ) : (
                  <Typography variant="h3">
                    Сүхбаатар дүүрэг, 1-р хороо, Нарны зам 59Г өргөтгөлд байрлах
                    "ТЭУ" эмнэлэгийн 3 давхар, Ulaanbaatar, Mongolia
                    <br />
                    Утас: 7711 1918
                    <br /> Цахим шуудан: Khanlor2021@gmail.com
                    <br /> Цахим хаяг: https: hanlor.mn
                  </Typography>
                )}
              </Box>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flexDirection: "row",
                  display: "flex",
                  justifyContent: "left",
                  marginTop: 50,
                }}
              >
                <FontAwesomeIcon
                  icon={faSquareFacebook}
                  size="2x"
                  style={{
                    color: "white",
                    marginRight: 10,
                    transition: "color 0.5s ease",
                    fontSize: 30,
                    cursor: "pointer",

                    "&:hover": {
                      color: "#007bff",
                    },
                  }}
                  onClick={() => {
                    window.open(
                      "https://www.facebook.com/khanlor.mn",
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                />
                <FontAwesomeIcon
                  icon={faSquareYoutube}
                  size="2x"
                  style={{
                    color: "white",
                    marginRight: 8,
                    transition: "color 0.5s ease",
                    fontSize: 30,
                    cursor: "pointer",

                    "&:hover": {
                      color: "#007bff",
                    },
                  }}
                  onClick={() => {
                    window.open(
                      "https://www.youtube.com",
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                />
                <FontAwesomeIcon
                  icon={faSquareTwitter}
                  size="2x"
                  style={{
                    color: "white",
                    marginRight: 8,
                    transition: "color 0.5s ease",
                    fontSize: 30,
                    cursor: "pointer",

                    "&:hover": {
                      color: "#007bff",
                    },
                  }}
                  onClick={() => {
                    window.open(
                      "https://x.com",
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                />
                <FontAwesomeIcon
                  icon={faSquareInstagram}
                  size="2x"
                  style={{
                    color: "white",
                    marginRight: 8,
                    transition: "color 0.5s ease",
                    fontSize: 30,
                    cursor: "pointer",

                    "&:hover": {
                      color: "#007bff",
                    },
                  }}
                  onClick={() => {
                    window.open(
                      "https://www.instagram.com",
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Container>

      <Container
        maxWidth={false}
        disableGutters={true}
        style={{
          backgroundColor: "#f2f2f2",
        }}
        id={"contact"}
      >
        <Container maxWidth={"lg"}>
          <Grid container spacing={0}>
            <Grid
              item
              lg={10}
              md={10}
              sm={12}
              xs={12}
              style={{
                display: "flex",
                // flexDirection: "column",
                justifyContent: "center",
                padding: 10,
              }}
            >
              <Link
                href="https://alphafox.mn"
                underline="none"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  textDecoration: "none",
                  "&:hover img": { transform: "scale(1.05)" },
                }}
              >
                {/* ✅ Logo/Icon */}
                <Box className="flex items-center cursor-pointer">
                  <Typography
                    variant={"body2"}
                    style={{
                      fontWeight: "700",
                      color: "#616A6B",
                    }}
                  >
                    {t("right_reserved")}
                  </Typography>
                  <Box
                    component="img"
                    src="https://alphafox.mn/developedLogo.png" // 👈 Replace with your icon path
                    alt="AlphaFox"
                    sx={{
                      width: 22,
                      height: 22,
                      ml: 1,
                    }}
                  />
                </Box>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Container>

      <CustomSnackBar
        open={snack.isOpen}
        msg={snack.msg}
        handleClose={handleCloseSnack}
        type={snack.type}
      />
    </div>
  );
};

export default Footer;
